__webpack_require__.p = "/reports-translations/referrals-hub/";